import { Button } from '@material-ui/core';
import Tooltip from '@material-ui/core/Tooltip';
import PropTypes from 'prop-types';
import React, { Component } from 'react';

import AddLink from '@/components/AddLink';
import Breadcrumbs from '@/components/Breadcrumbs';
import Page from '@/components/Page';
import PageContent from '@/components/PageContent';
import PageHeader from '@/components/PageHeader';
import PageTitle from '@/components/PageTitle';
import { ROUTE_PATH as CREATE_MERCHANT_PATH } from '@/features/merchantCreatePage/consts/index';
import { downloadXls } from '@/features/merchantsPage/utils';

import Table from './Table';

class Merchants extends Component {
  static propTypes = {
    error: PropTypes.any,
    merchantIds: PropTypes.arrayOf(PropTypes.any).isRequired,
    isLoading: PropTypes.bool.isRequired,
    totalCount: PropTypes.number.isRequired,
  };

  static defaultProps = {
    error: null,
  };

  render() {
    const { error, merchantIds, isLoading, totalCount, classes } = this.props;

    return (
      <Page>
        <PageHeader borderBottom gutterBottom={false}>
          <Breadcrumbs />
          <PageTitle gutterBottom={false}>Список арендаторов</PageTitle>
        </PageHeader>
        <PageContent>
          <div className={classes.wrapper}>
            <Button
              variant="contained"
              color="primary"
              className={classes.excelButton}
              onClick={downloadXls}
            >
              Вывести в Excel
            </Button>
            <Tooltip title="Добавить арендатора">
              <AddLink to={CREATE_MERCHANT_PATH} />
            </Tooltip>
            <Table
              error={error}
              items={merchantIds}
              isLoading={isLoading}
              totalCount={totalCount}
            />
          </div>
        </PageContent>
      </Page>
    );
  }
}

export default Merchants;
